export default __webpack_public_path__ + "static/oxygen-cca45c6e430b73cfeb104cb8d2abd0d7.png";